function BuilderDnaCard({ builderDna, isOwner }) {
  if (!builderDna.totalMods) {
    if (!isOwner) return null;
    return <section className="builder-dna-card"><h2 className="mybuildid-section-heading">Builder DNA</h2><p className="builder-dna-empty">Add mods to your builds to reveal your Builder DNA.</p></section>;
  }
  const summary = builderDna.categories.map((item) => `${item.displayName} ${item.percentage}%`).join(", ");
  return (
    <section className="builder-dna-card" aria-labelledby="builder-dna-title">
      <h2 id="builder-dna-title" className="mybuildid-section-heading">Builder DNA</h2>
      <strong className="builder-dna-label">{builderDna.label}</strong>
      <div className="builder-dna-bar" role="img" aria-label={`Builder DNA distribution: ${summary}.`}>
        {builderDna.categories.map((item, index) => <span key={item.category} style={{ width: `${item.percentage}%`, background: index === 0 ? "#e10600" : `rgba(255,255,255,${Math.max(.12, .34 - index * .055)})` }} />)}
      </div>
      <div className="builder-dna-list">{builderDna.categories.slice(0, 4).map((item) => <div key={item.category}><span>{item.displayName}</span><strong>{item.percentage}%</strong></div>)}</div>
      <p className="builder-dna-context">Based on {builderDna.totalMods} documented {builderDna.totalMods === 1 ? "mod" : "mods"} across {builderDna.buildCount} {builderDna.buildCount === 1 ? "build" : "builds"}</p>
    </section>
  );
}
export default BuilderDnaCard;
